var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "./fileProgressBar.css";
import * as Configs from "../../app-lib/constants";
import "../../lib/knockout_pscUpload";
import "../../lib/knockout_datafileUpload";
import '../../lib/knockout_datePicker';
import '../../lib/knockout_fileUpload';
var fd = new FormData(); //提交文件
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        var _this = _super.call(this, "", root, {}) || this;
        // 进度条弹框
        _this.hiddenBodyOne = ko.observable(true);
        _this.hiddenBodytwo = ko.observable(false);
        _this.fileList = ko.observableArray([]); //文件列表
        _this.fileText = ko.observable(''); //文件统计提示
        _this.hiddenBar = ko.observable(false);
        _this.hiddenWord = ko.observable(true);
        _this.hiddenWan = ko.observable(false);
        _this.stime = ko.observable(); //开始时间
        _this.etime = ko.observable(); //结束时间
        _this.localTime = ko.observable(0); //本地上传需要多久
        _this.progressBar = ko.observable(0); //进度条%
        _this.fileData = ko.observableArray(); //上传的文件的ID和name
        _this.pid = ko.observable(''); //文件柜上传id
        _this.cid = ko.observable(''); //表单上传id
        _this.fileUploadUrl = ko.observable(''); //文档上传url
        _this.fileSize = ko.observable(0); //文件大小
        _this.hiddenX = ko.observable(true); //点击删除文件
        return _this;
    }
    // 继续添加文件
    MyModel.prototype.fileChange = function (r, e) {
        this.hiddenBodyOne(false);
        this.hiddenBodytwo(true);
        var input = e.currentTarget;
        if ((this.fileList().length + input.files.length) > 10) {
            return window.popBox.show('一次最多上传10个文件!');
        }
        for (var i = 0; i < input.files.length; i++) {
            if (Number(input.files[i].size) > 10485760) {
                return window.popBox.show('单个文件不能超过10M');
            }
            // 判断重复文件
            for (var n = 0; n < this.fileList().length; n++) {
                if (this.fileList()[n].fileName == input.files[i].name) {
                    return window.popBox.show(input.files[i].name + '文件已存在!');
                }
            }
            if (i >= 10) {
                return window.popBox.show('一次最多上传10个文件!');
            }
            this.fileList.push({ 'fileName': input.files[i].name, 'fileLength': input.files[i].size });
            fd.append("file", input.files.item(i)); //后台使用参数名file数组来获取所有上传文件
            // let fl: number = 0;
            if (this.fileList().length > 5) {
                var fs = this.container.querySelector('.file-zs');
                fs.style.height = '40%';
            }
        }
        this.fileSize(0);
        var fl = 0;
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
    };
    // 上传文件
    MyModel.prototype.fileUploadBar = function () {
        this.hiddenBar(true);
        this.hiddenWord(false);
        this.hiddenX(false);
        var that = this;
        var xhr = new XMLHttpRequest(); // XMLHttpRequest 对象
        var a = 0;
        fd.append("uid", window.localStorage.getItem('UserId')); //上传者账号
        fd.append("pid", ''); //项目id点击的时候加载进来 this.pid()
        xhr.open("post", Configs.Configs.fileUpdateUrl + '/api/ice/upload', true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
        xhr.upload.onprogress = function (ev) {
            //如果ev.lengthComputable为true就可以开始计算上传进度
            //上传进度 = 100* ev.loaded/ev.total
            if (ev.lengthComputable) {
                var precent = 10 * ev.loaded / ev.total; //更改进度条，及百分比
                var bar = that.container.querySelector('.file-bar-blue');
                bar.style.width = precent + '%';
                var percentText = (100 * ev.loaded / ev.total).toFixed(2);
                var percentDiv = that.container.querySelector('.file-upload-word');
                percentDiv.textContent = (Number(percentText) / 2).toFixed(2) + '%';
                that.progressBar(precent);
                if (a == 0) {
                    var date1 = new Date(); //开始时间
                    that.stime(date1);
                }
                if (precent == 10) {
                    var date2 = new Date(); //结束时间
                    that.etime(date2);
                    var date3 = that.etime().getTime() - that.stime().getTime(); //时间差的毫秒数
                    that.localTime(date3);
                    var num = (that.localTime() / 100);
                    var ti = (num / 10);
                    that.progressFunction(num, ti, 400);
                }
                a++;
            }
        };
        xhr.send(fd);
        // xhr.onreadystatechange = function (ev: any) {
        // 	//readystate为2表示请求已完成并就绪
        // 	if (ev.currentTarget.readyState == 2) {
        // 		that.hiddenBar(true);
        // 		that.hiddenWord(false);
        // 		that.hiddenWan(true);
        // 	}
        // }
        xhr.onload = function (ev) {
            that.hiddenBar(true);
            that.hiddenWord(false);
            var bar = that.container.querySelector('.file-bar-blue');
            bar.style.width = 25 + '%';
            var percentDiv = that.container.querySelector('.file-upload-word');
            percentDiv.textContent = 100 + '%';
            that.fileData(JSON.parse(xhr.response).data);
            if (xhr.response) {
                that.hiddenWan(true);
            }
            console.log(that.fileData());
        };
    };
    // 进度条百分比控制
    MyModel.prototype.progressFunction = function (num, ti, n) {
        var _this = this;
        if (num < 0) {
            return; //函数结束条件
        }
        if (num > 14) {
            num = 14;
            n = 500;
        }
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = this.progressBar() + ti + '%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = (Number(this.progressBar() * 4) + Number(ti)).toFixed(2) + '%';
        num--;
        this.progressBar(this.progressBar() + ti);
        ti = (num / 12);
        setTimeout(function () {
            _this.progressFunction(num, ti, n);
        }, n);
        console.log('--------------进入定时器' + num);
    };
    // 删除选中的某个文件
    MyModel.prototype.deleteFileUpload = function (r, e) {
        // console.log(e.fileName)
        for (var i = 0; i < this.fileList().length; i++) {
            if (e.fileName == this.fileList()[i].fileName) {
                this.fileList().splice(i, 1);
            }
        }
        this.fileList(this.fileList());
        // console.log(this.fileList())
        var arr1 = fd.getAll('file');
        for (var n = 0; n < fd.getAll('file').length; n++) {
            var file = fd.getAll('file')[n];
            if (e.fileName == file.name) {
                // fd.getAll('file').splice(n,1)
                arr1.splice(n, 1);
                arr1 = arr1;
                fd.delete('file');
                for (var m = 0; m < arr1.length; m++) {
                    fd.append('file', arr1[m]);
                }
            }
        }
        this.fileSize(0);
        var fl = 0;
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
        if (this.fileList().length <= 5) {
            var fs = this.container.querySelector('.file-zs');
            fs.style.height = '30%';
        }
        // console.log(fd.getAll('file'))
    };
    //确定
    MyModel.prototype.sureCk = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        obj.value = '';
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        fd.delete('file');
        fd.delete('pid');
        fd.delete('uid');
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // // 更新数据
        // this.data = {};
        // this.data.fid = this.saveFolderNameId();
        // this.data.userId = authorization.getUserId();
        // this.loadData();
        // if (this.popur4() == 1) {
        // 	this.popur4(0)
        // } else {
        // 	this.popur4(1);
        // }
    };
    // 点击叉号关闭
    MyModel.prototype.closeFileUpload = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        obj.value = '';
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        fd.delete('file');
        fd.delete('pid');
        fd.delete('uid');
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // // 更新数据
        // this.data = {};
        // this.data.fid = this.saveFolderNameId();
        // this.data.userId = authorization.getUserId();
        // this.loadData();
        // if (this.popur4() == 1) {
        // 	this.popur4(0)
        // } else {
        // 	this.popur4(1);
        // }
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
        this.c.bind();
    };
    MyViewModel.prototype.update = function (arg) {
        this.c.hiddenBodyOne(true);
        this.c.hiddenBodytwo(false);
        if (arg.routeData.query["cid"]) {
            this.c.cid(arg.routeData.query["cid"]); //表单上传id
        }
        if (arg.routeData.query["pid"]) {
            this.c.pid(arg.routeData.query["pid"]); //文件柜上传id
        }
        if (arg.routeData.query["furl"]) {
            this.c.fileUploadUrl(arg.routeData.query["furl"]); //文档上传url
        }
        return Promise.resolve();
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
